<template>
  <div class="before">
    <div v-for="(value, key, i) in data" :key="i">
      <app-sel
        styling="inline"
        key-name="label"
        v-model="nutrients[key].active"
        :items="Object.values(nutrients[key].variants)"
      >
        <template v-slot="{ items }">
          <app-sel-opt
            :value="item"
            v-for="(item, j) in items"
            :key="j"
          >
            {{ item.label }}
          </app-sel-opt>
        </template>
      </app-sel>

      <span v-if=" nutrients[key].variants[nutrients[key].active].factor == 1">
        {{nutrients[key].original.toFixed(2)}}
      </span>
      
      <span v-else>
        {{getFactoredValue(nutrients[key].variants[key].label, nutrients[key].active, nutrients[key].original).toFixed(2)}}
      </span>
    </div>
    <div>
      <span class="weight">
        {{$ml.get(`Total N:`)}}
      </span>
      <span class="weight">
        {{getTotal}}
      </span>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    data: Object
  },
  data () {
    return {
      nutrients: {
        'NO3': {
          value: 0,
          active: 'NO3',
          original: 0,
          variants: {
            'N-NO3': {
              label: 'N-NO3',
              factor: 1,
            },
            NO3: {
              label: 'NO3',
              factor: 4.427,
            },
          }
        },
        'NH2': {
          value: 0,
          active: 'NH2',
          original: 0,
          variants: {
            'N-NH2': {
              label: 'N-NH2',
              factor: 1,
            },
            NH2: {
              label: 'NH2',
              factor: 1.142,
            },
          }
        },
        'NH4': {
          value: 0,
          active: 'NH4',
          original: 0,
          variants: {
            'N-NH4': {
              label: 'N-NH4',
              factor: 1,
            },
            NH4: {
              label: 'NH4',
              factor: 1.285,
            },
          }
        },

      },
    }
  },
  watch: {
    data (val) {
      this.setVal();
    },
    nutrients: {
      handler: function (val) {
        this.refreshVal();
      },
      deep: true
    }
  },
  methods: {

    getFactoredValue(nut, active, value) {
      console.log(nut, active, value)
      let val = value * this.nutrients[nut].variants[active].factor;
      return val;
    },
    
    getVal: function (nut, active) {
      var val = this.nutrients[nut].original * this.nutrients[nut].variants[active].factor;
      return Number(val.toFixed(2));
    },
    getOriginal: function (nut, active, value) {
      var val = value / this.nutrients[nut].variants[active].factor;
      return Number(val);
    },
    setVal: function () {
      for (var key in this.data) {
        if (this.nutrients[key]) {
          this.nutrients[key].active = 'N-' + key;
          this.nutrients[key].original = this.getOriginal(key, this.nutrients[key].active, this.data[key]);
          this.nutrients[key].value = this.getVal(key, this.nutrients[key].active);
        }
      }
    },
    refreshVal: function () {
      for (var key in this.data) {
        if (this.nutrients[key]) {
          this.nutrients[key].value = this.getVal(key, this.nutrients[key].active);
        }
      }
    }
  },
  created () {
    this.setVal();  
  },
  computed: {
    getTotal () {
      var res = 0;
      let value = 0;
      for (let n in this.nutrients) {
        for (let v in this.nutrients[n].variants) {
          let variant = this.nutrients[n].variants[v]
          if(v != 'NH2' && v != 'NO3' && v != 'NH4') {
            res += (this.nutrients[n].original * variant.factor)
          }
        }
      }
        
      return res.toFixed(2);
      },
  }
}
</script>

<style lang="scss" scoped>
  .before {
    width: 100%;
    .app-sel {
      min-width: 120px;
    }
    &>div {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 200px 8px 0px;
      border-top: solid 1px rgba(76, 80, 86, 0.1);
      border-bottom: solid 1px rgba(76, 80, 86, 0.1);

      span {
        font-size: 16px;
        font-weight: 400;

        &.weight {
          font-weight: 500;
        }
      }

      &:last-child {
        padding: 20px 200px 20px 12px;
      }

      @media (max-width: 500px) {
        padding: 8px 0 8px 0px;

        &:last-child {
          padding: 20px 0 20px 12px;
        }
      }
    }
  }
</style>
